import Svg, { Path } from 'react-native-svg'

export const TransactionHistoryIcon = ({ height = 20, width = 20, color = '#141414' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M14.167 10a4.167 4.167 0 1 0 0 8.334 4.167 4.167 0 0 0 0-8.334Zm1.25 5a.833.833 0 0 1-.834.834h-1.666a.833.833 0 1 1 0-1.667h.833v-1.25a.833.833 0 0 1 1.667 0V15Zm-8.75 0a.834.834 0 0 1 0-1.666H8.4a5.833 5.833 0 0 1 .983-2.5H6.667a.833.833 0 1 1 0-1.667h4.508a5.834 5.834 0 0 1 2.992-.833c.866 0 1.72.197 2.5.575V4.167a2.5 2.5 0 0 0-2.5-2.5H5.833a2.5 2.5 0 0 0-2.5 2.5v11.667a2.5 2.5 0 0 0 2.5 2.5h4.259A5.833 5.833 0 0 1 8.425 15H6.667Zm0-10h2.5a.833.833 0 1 1 0 1.667h-2.5a.833.833 0 1 1 0-1.667Z"
      />
    </Svg>
  )
}
